import {
  selectCurrentPlayer,
  selectIsInitiativeInterceptedWithIsolationism,
  selectNextInitiativePlayerId,
  selectPendingBuildings
} from "../../../redux/reducers/sharedStateReducer/selectors";
import {calcUsedConstructionActions} from "../construction/calcUsedConstructionActions";

const NO_PENDING_BUILDINGS = [];

/**
 * Действия строительства игрока на этот ход — те же числа, что в шапке матча
 * (HeaderMineZone): used — использованные с учетом перехвата инициативы
 * (кроме Изоляционизма) и очистки рынка политик, total — всего.
 * Отложенные строения в состоянии — ход того, кто ходит: у остальных игроков
 * использованных строений нет.
 *
 * @returns {{used: number, total: number}}
 */
export const getConstructionActions = (state, player) => {
  const isCurrentPlayer = selectCurrentPlayer(state)?.id === player.id;
  const pendingBuildings = isCurrentPlayer
    ? (selectPendingBuildings(state) || NO_PENDING_BUILDINGS)
    : NO_PENDING_BUILDINGS;

  return {
    used: calcUsedConstructionActions(
      player,
      pendingBuildings,
      selectNextInitiativePlayerId(state),
      selectIsInitiativeInterceptedWithIsolationism(state)
    ),
    total: player.constructionPhaseActions || 0,
  };
};
